<template>
  <TopBar title="What is the highest qualification you have attempted or completed?" :step="step"/>
  <div class="step">
    <div v-for="(field, index) in fields" :key="field">
      <button class="btn-select" @click="toggleSelect(index)" :class="{ selected: field === selected }">
        <div v-html="field"></div>
      </button>
    </div>
  </div>
  <BottomBar :step="step" :show-next="false"/>
</template>
<script>
import { mapState } from 'vuex'

import TopBar from '@/components/TopBar'
import BottomBar from '@/components/BottomBar'

export default {
  props: {
    step: {
      required: true
    }
  },
  components: {
    TopBar,
    BottomBar
  },
  computed: mapState({
    selected: state => state.formData.qualification
  }),
  data () {
    return {
      fields: ['Certificate IV', 'Foundation Studies', 'Diploma', 'Advanced Diploma', 'Associate Degree', 'Bachelor Degree', 'Graduate Certificate', 'Graduate Diploma', 'Masters', 'Doctorate']
    }
  },
  methods: {
    toggleSelect (index) {
      this.$store.commit('setFormData', { key: 'qualification', value: this.fields[index] })
      this.$router.push('/step/6')
    }
  }
}
</script>
<style lang="scss">
@import './../assets/scss/mixins';

.step-5 {
  .step {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    // padding-left: 2rem;
    // padding-right: 2rem;

    > div {
      flex-grow: 0;
      display: flex;
      flex-basis: 50%;
      aspect-ratio: 1.7;

      button {
        width: 100%;

        div {
          font-size: 16px;

          @include respond-above(lg) {
            font-size: 18px;
          }
        }
      }

      @include respond-above(lg) {
        flex-basis: 20%;
        aspect-ratio: 1.21;
      }
    }
  }
}
</style>
